/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[xbaht-core-menu-horizontal-item]',
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss',
  standalone: false
})
export class CoreMenuHorizontalItemComponent {
  @Input()
  public item: any;
}
